

import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import { addChatSubTitleWithQuestion, addNewQuestionLocal } from "../../../features/aiControl/aiControlSlice"
import AIQuestionItemAdd from "../../aiControl/AIQuestionItemAdd"
import InputNewSubTitle from "../../shared/input/ai/InputNewSubTitle"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 700px;
        max-height: 600px;
        overflow: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            width: 100%;
            padding: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            
            .new-sub-title-container{
                    width: 100%;
                    border: 2px solid ${({theme}) => theme.mainBorderColor};
                    border-bottom: none;
                    padding: 10px 30px;
                    border-top-right-radius: 10px;
                    border-top-left-radius: 10px;

                    h4{
                        color: var(--color-main);
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                        padding-bottom: 10px;
                    }
                }
            .question-list{
                border: 2px solid ${({theme}) => theme.mainBorderColor};
                width: 100%;
                border-bottom-right-radius: 10px;
                border-bottom-left-radius: 10px;
                margin-bottom: 20px;



                .add-btn{
                    width: 100%;
                    background-color: ${({theme}) => theme.mainBorderColor};
                    height: 40px;
                    display: flex;
                    justify-content: center;
                    align-items:center;
                    font-size: 3.4rem;
                    color: #fff;
                }
            }
        }
    }
`
const AddAiChatSubTitleModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)

    const [newSubTitle, setNewSubTitle] = useState("")

    const { lockScroll, unlockScroll } = useScrollLock();

    const {questionList, aiQuestionGroupData} = useSelector(state => state.aiControl)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = () => {


        const list = questionList.map((item)=> {
            const {id, ...others} = item
            return others
        }) 

        const data = {
            titleId: aiQuestionGroupData.id,
            chatAiReadyDefaultMessages: [
                {
                    subTitleName:newSubTitle,
                    aidefaultMesssages: list
                }
            ]
        }

        dispatch(addChatSubTitleWithQuestion(data))
    }


  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <div className="content">
            <div className="new-sub-title-container">
                <h4>Yeni Alt Başlık İsmi</h4>
                <InputNewSubTitle data={newSubTitle} setData={setNewSubTitle} name={"addNewSubTitle"} labelText={"Alt Başlık Ekle"} inputWidth={"160px"}/>
            </div>
            <div className="question-list">
                {
                    questionList.map((item, i) => (
                        <AIQuestionItemAdd item={item} order={i+1} isItLast={i+1 === questionList.length}/>
                    ))
                }
                <button className="add-btn" onClick={()=>dispatch(addNewQuestionLocal())}>+</button>
            </div>
            <Btn width={"200px"} bgColor="#E85446" height="40px" color="#fff" handleClick={handleSubmit}>Tamamla</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default AddAiChatSubTitleModal